import { httpGet } from 'utils';
import { logError } from 'components/LogError';
import { CampaignsOffersType } from '../types';

interface FetchCampaignOffersResponseType {
  data: CampaignsOffersType[];
  count?: number;
}

export interface campaignsListType {
  id: string;
  name: string;
  numberOfUnitsAllowed?: number;
}
export interface fetchCampaignOffersParams {
  // queryKey: string;
  listOfCampaigns: campaignsListType[];
  pageSize: number;
  page: number;
}

/* eslint-disable no-await-in-loop */
export const fetchCampaignOffers = async (params: fetchCampaignOffersParams, signal: AbortSignal | undefined) => {
  const { listOfCampaigns, page, pageSize } = params;
  if (!listOfCampaigns && !params?.listOfCampaigns?.length) return [];

  const campaignData: CampaignsOffersType[] = [];
  for (let i = 0; i < listOfCampaigns.length; i++) {
    await new Promise((resolve) => {
      setTimeout(async () => {
        // console.log('fetchResponse count ', listOfCampaigns[i]);
        const { id: campaignId, name: campaignName, numberOfUnitsAllowed } = listOfCampaigns[i];
        try {
          const url = `portal/Campaigns/${campaignId}/Offers?pageSize=${pageSize}&page=${page}`;
          const fetchResponse = await httpGet<FetchCampaignOffersResponseType>(url, undefined, true, signal);
          let resp = fetchResponse?.data ?? [];
          if (resp.length > 0)
            resp = resp.map((item) => ({
              ...item,
              numberOfUnitsAllowed: numberOfUnitsAllowed ?? -1,
              stringRef: `${campaignId};${campaignName}`,
            }));
          campaignData.push(...resp);
        } catch (error) {
          // Skip this campaign rather than failing the whole batch, so one bad
          // campaign id cannot blank out the offers of every healthy campaign.
          logError(error as Error, { tags: { userFlow: 'campaignOfferPurchase', campaignId } });
        }
        resolve(null);
      }, 1000);
    });
  }

  return Promise.resolve(campaignData);
};
